module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-180x180.6f589e6dfd0dff14c0ded22b6874e515.png";